import { DropdownItemProps } from "semantic-ui-react";
import { IJustification } from "../models/justification";
import { getAuthorizationProperties } from "./authorizationHelper";

export async function getJustifications(): Promise<DropdownItemProps[]> {
    return fetch("/api/justifications", {
        method: "GET",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    }).then(async (res: Response) => {
        const props: DropdownItemProps[] = [];
        if (res.ok) {
            const result: IJustification[] = await res.json();
            result.forEach(j => props.push({ key: j.guid, text: j.value, value: j.value }));
        }
        return props;
    });
}

export async function addJustification(dto: IJustification): Promise<Response> {
    return fetch("/api/justifications", {
        method: "POST",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
        body: JSON.stringify(dto),
    });
}

export async function deleteJustification(guid: string): Promise<Response> {
    return fetch("/api/justifications/" + guid, {
        method: "DELETE",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    });
}
